import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Typography,
  MenuItem,
  Select,
  Grid,
  Paper,
  IconButton,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { makeStyles, useTheme } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import InvestNowStepper from "../ui/investNowStepper";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useGA4React } from "ga-4-react";

import { useNavigate } from "react-router-dom";
import { resetData, updateData } from "../../features/data/data.slice";
import {
  completeStep,
  resetSteps,
  updateStep,
} from "../../features/stepper.slice";
import {
  resetSubmition,
  saveSubmition,
} from "../../features/submition/submition.slice";
import { useTitle } from "../../providers/titleProvider";
import HelpContactConsultantCard from "../dialogs/helpContactConsultant";
import ContactUsDialog from "../dialogs/contactUs";
import { updateFormStepperSteps } from "../../features/formStepper.slice";
import { resetUser } from "../../features/user/user.slice";
import { checkObject } from "../../libs/helpers";
import { Report, ReportPageView } from "../../libs/loggers";
import { numberToCurrency } from "../../libs/helpers";
import PrimaryButton from "../ui/buttons/primaryButton";
import CloseIcon from "@mui/icons-material/Close";
import DropdownInfoBlock from "../ui/feedback/dropdownInfoBlock";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  radioTable: {
    marginTop: theme.spacing(3),
  },
  checkbox: {
    marginTop: theme.spacing(3),
  },
  card: {
    position: "relative",
    cursor: "pointer",
    minWidth: 320,
    maxWidth: 320,
    height: 250,
    background: theme.palette.mode === "light" ? "#fff" : "#373434",
    textAlign: "center",
    marginBottom: "20px",
    marginRight: "20px",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50px",
    position: "relative",
  },
  infoBox: {
    backgroundColor: theme.palette.mode === "light" ? "#fff" : "#231F20",
    padding: "16px",
    borderRadius: "5px",
    maxWidth: "93em",
  },
  overlay: {
    background: theme.palette.mode === "light" ? "#3734348a" : "#eae8e470",
    cursor: "context-menu",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  overlayDisabled: {
    background: theme.palette.mode === "light" ? "#3734348a" : "#eae8e470",
    cursor: "context-menu",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  tick: {
    opacity: 0.5,
    width: "200px",
    [theme.breakpoints.down("sm")]: {
      width: "150px",
    },
    height: "auto",
    margin: "auto",
  },
  header: {
    fontWeight: "bold",
    marginTop: "30px",
    marginLeft: "30px",
    marginRight: "30px",
    fontSize: "14px",
  },
  menuItem: {
    backgroundColor: theme.palette.mode === "light" ? "#F3F2F1" : "transparent",
    whiteSpace: "break-spaces",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "100%",
    maxWidth: "100%",
  },
  select: {
    ...theme.typography.h5,
    borderRadius: "30px",
    boxShadow:
      theme.palette.mode === "light"
        ? "3px 3px 6px rgba(0, 0, 0, 0.1), -3px -3px 6px rgba(255, 255, 255, 0.7)"
        : "none",

    background: theme.palette.background.paper,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
  },
  smallScreenSelect: {
    [theme.breakpoints.up("sm")]: {
      minWidth: "600px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "150px",
      width: "100%",
      paddingRight: "5px",
      paddingLeft: "5px",
    },
  },
  icon: {
    width: "150px",
    marginRight: "16px",
    [theme.breakpoints.down("sm")]: {
      width: "80px",
    },
  },
  paper: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "900px",
    backgroundColor: theme.palette.mode === "light" ? "#F3F2F1" : "transparent",
    padding: "16px",
    borderRadius: "30px",
    [theme.breakpoints.down("sm")]: {
      padding: "8px",
    },
  },
}));

const schema = yup.object().shape({
  // onBehalfOfMinor: yup.bool().required(),
  vehicle: yup.string().required("Please select a investment vehicle"),
});

function InvestmentSelect() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  let ga4React = useGA4React();
  const [confirmResetOpen, setConfirmResetOpen] = useState(false);
  const { setTitle } = useTitle();
  const submitionData = useSelector((state) => state.submition.data);

  const [openContactUs, setOpenContactUs] = useState(false);
  let page = window.location.pathname.replace(/^\/|\/$/g, "");
  const {
    control,
    handleSubmit,
    trigger,
    watch,

    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });
  const investVehicles = useSelector(
    (state) => state.investVehicle.value.vehicles
  );
  const stepData = useSelector((state) => state.data.value);
  const stepper = useSelector((state) => state.stepper.value);
  const userId = useSelector((state) => state.submition.data?.userId);
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );

  const [selectedVehicleIndex, setSelectedVehicleIndex] = useState(null);
  const [benefitsDialogOpen, setBenefitsDialogOpen] = useState(false);
  const requireHelp = useSelector((state) => state.stepper.value.requireHelp);
  const watchVehicle = watch("vehicle");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const eventInfo = {
      action: "select",
      category: "vehicle",
      description: "Select Vehicle",
      value: {
        value: "select_vehicle",
        step: stepper.active + 1,
        currentPage: page,
        vehicle: watchVehicle,
      },
    };
    if (watchVehicle) {
      Report(eventInfo, userId, submitionId);
    }
  }, [watchVehicle]);

  useEffect(() => {
    ReportPageView(page, userId, submitionId);
  }, []);

  useEffect(() => {
    setTitle("Select Investment Vehicle");
  }, [setTitle]);

  useEffect(() => {
    register("vehicle");
  }, []);

  useEffect(() => {
    const currentVehicle = stepData.vehicle;

    setValue("vehicle", currentVehicle);
  }, [stepData.vehicle]);

  useEffect(() => {
    const currentVehicle = stepData.vehicle;
    if (watchVehicle && currentVehicle && watchVehicle !== currentVehicle) {
      setConfirmResetOpen(true);
    }

    if (ga4React && watchVehicle) {
      ga4React.event("vehicle_select", `${watchVehicle}`, "investment_vehicle");
    }
  }, [watchVehicle]);

  const onSubmit = (data) => {
    dispatch(updateData({ ...data }));
  };

  const onNext = async (vehicle) => {
    const newStep = stepper.active + 1;
    const isValid = await trigger();
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: "clicked next",
      value: {
        nextPage: stepper.steps[newStep].url,
        prevPage: page,
        step: stepper.active + 1,
        value: "next",
      },
    };

    if (isValid) {
      Report(eventInfo, userId, submitionId);
      handleSubmit(onSubmit)();

      dispatch(updateFormStepperSteps(vehicle.formSections));
      dispatch(updateStep(newStep));
      dispatch(completeStep(stepper.active));
      navigate(stepper.steps[newStep].url);
    }
  };

  const onValidation = async () => {
    const isValid = await trigger();
    return isValid;
  };

  const handleCloseReset = () => {
    setValue("vehicle", stepData.vehicle);
    setConfirmResetOpen(false);
  };
  const resetVehicle = () => {
    setSelectedVehicleIndex(null);
  };

  const confirmChangeVehicle = async () => {
    const data = getValues();

    dispatch(resetSubmition());
    dispatch(resetData());
    dispatch(resetSteps());
    dispatch(updateStep(1));
    dispatch(completeStep(0));
    dispatch(resetUser());
    setConfirmResetOpen(false);

    await new Promise((resolve) => setTimeout(resolve, 0));

    let newSubmition;
    const vehicleIndex = investVehicles.findIndex(
      (object) => object.name === watchVehicle
    );
    const choseVehicle = investVehicles[vehicleIndex];

    if (checkObject(submitionData)) {
      newSubmition = { ...submitionData };
      newSubmition.vehicle = watchVehicle;

      if (choseVehicle) {
        dispatch(updateFormStepperSteps(choseVehicle.formSections));
      }

      dispatch(saveSubmition({ ...newSubmition }));
      dispatch(updateData({ ...data }));
    }

    setValue("vehicle", watchVehicle);
  };

  const handleOpenContactUs = () => {
    if (benefitsDialogOpen) {
      setBenefitsDialogOpen(false);
    }
    setOpenContactUs(true);
  };

  const getConsultantText = (requireHelp) =>
    requireHelp ? "speak to a consultant" : "Speak to a consultant";

  const getHeadingText = (requireHelp) =>
    requireHelp
      ? "Why would you like to invest?"
      : "How would you like to invest?";

  const isLightMode = useMediaQuery("(prefers-color-scheme: light)");
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const stepperContent = () => {
    const selectedVehicle = investVehicles.find(
      (vehicle) => vehicle.name === watchVehicle
    );

    const iconSource = selectedVehicle
      ? isLightMode
        ? selectedVehicle.icon.replace(/black/g, "white")
        : selectedVehicle.icon
      : null;

    const shouldRenderContactUs =
      selectedVehicle && !selectedVehicle.formSections;

    return (
      <>
        <Box className={classes.root}>
          <Typography pt={3} variant="h4">
            {getHeadingText(requireHelp)}
          </Typography>
          <DropdownInfoBlock
            title="How to choose my vehicle"
            content="Selecting a suitable investment vehicle is important. Each
                investment vehicle is a uniquely designed product connected to a
                specific purpose, assisting you to reach your investment goals.
                Your selected investment vehicle will house your investment
                solution / fund, which you will choose in Step 3."
            sx={{ mt: 2, cursor: "pointer" }}
            defaultOpen={false}
          />
          <Box
            mt={3}
            mb={isSmallScreen ? 3 : 4}
            display={isSmallScreen ? "flex-start" : "flex"}
            flexDirection={isSmallScreen ? "column" : "row"}
            justifyContent="center"
            alignItems="center"
            width="100%"
            whiteSpace="nowrap"
          >
            <Typography
              variant="h5"
              mb={isSmallScreen ? 1 : "auto"}
              mr={2}
              mt="auto"
              textAlign={isSmallScreen ? "center" : "default"}
            >
              {requireHelp ? "I would like to..." : "Investment Vehicle:"}
            </Typography>
            <Select
              label="Select Vehicle"
              className={`${classes.select} ${classes.smallScreenSelect}`}
              name="vehicle"
              value={watch("vehicle") || ""}
              onChange={(event) => {
                setValue("vehicle", event.target.value);
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {investVehicles.map((vehicle, index) => (
                <MenuItem
                  key={vehicle.id}
                  value={vehicle.name}
                  className={classes.menuItem}
                >
                  {requireHelp ? vehicle.description2 : vehicle.description1}
                </MenuItem>
              ))}
              <MenuItem value="assistance" className={classes.menuItem}>
                {getConsultantText(requireHelp)}
              </MenuItem>
            </Select>
          </Box>
          {watchVehicle === "assistance" && (
            <HelpContactConsultantCard
              resetVehicle={resetVehicle}
              requireHelp={requireHelp}
            />
          )}

          {selectedVehicle && (
            <Paper className={classes.paper}>
              <Box
                display={"flex"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                mb={1}
              >
                <img
                  src={iconSource}
                  alt="Vehicle Icon"
                  className={classes.icon}
                />
                <Typography
                  variant={isSmallScreen ? "h5" : "h3"}
                  fontWeight={500}
                >
                  Product: {isSmallScreen && <br />}
                  {selectedVehicle.name}
                </Typography>
              </Box>

              <Box p={1}>
                <Typography variant={"h5"} mb={1} fontWeight={500}>
                  Suitable For
                </Typography>
                <Typography variant={"body1"}>
                  {selectedVehicle.suitableFor}
                </Typography>
              </Box>

              <Box p={1} mb={2} mt={2}>
                <Typography variant={"h5"} mt={1} mb={1} fontWeight={500}>
                  Investment amounts per fund
                </Typography>
                {selectedVehicle.minimums.lumpsum && (
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <Typography variant={"body1"}>
                        Initial lumpsum investment
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} display={"flex"}>
                      <Typography variant={"body1"}>
                        {numberToCurrency(selectedVehicle.minimums.lumpsum)}
                      </Typography>
                      {selectedVehicle.minimums.monthly > 0 && (
                        <Typography variant={"body1"} ml={2}>
                          {" "}
                          OR
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                )}

                {selectedVehicle.minimums.monthly > 0 && (
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <Typography variant={"body1"}>
                        Monthly debit order
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant={"body1"}>
                        {numberToCurrency(selectedVehicle.minimums.monthly)}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {selectedVehicle.minimums.additional && (
                  <>
                    {" "}
                    <br />
                    <Typography variant={"body1"}>
                      {" "}
                      {selectedVehicle.minimums.additional}
                    </Typography>
                  </>
                )}
              </Box>
              <Box
                display={"flex"}
                justifyContent={isSmallScreen ? "center" : "flex-end"}
                flexWrap={"wrap"}
                p={2}
              >
                <PrimaryButton
                  variant={"outlined"}
                  sx={{ borderRadius: "30px", m: 1, minWidth: "130px" }}
                  onClick={() => setBenefitsDialogOpen(true)}
                >
                  Learn More
                </PrimaryButton>
                {shouldRenderContactUs ? (
                  <PrimaryButton
                    sx={{ borderRadius: "30px", m: 1, minWidth: "130px" }}
                    onClick={() => handleOpenContactUs()}
                  >
                    Contact Us
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    onClick={() => {
                      onNext(selectedVehicle);
                    }}
                    sx={{ borderRadius: "30px", m: 1, minWidth: "130px" }}
                  >
                    Select Product
                  </PrimaryButton>
                )}
              </Box>
            </Paper>
          )}
        </Box>

        <Dialog
          open={benefitsDialogOpen}
          onClose={() => setBenefitsDialogOpen(false)}
          fullWidth
          maxWidth="md"
          PaperProps={{
            style: { borderRadius: "30px" },
          }}
        >
          <DialogContent>
            <IconButton
              aria-label="close"
              color="primary"
              size="large"
              onClick={() => setBenefitsDialogOpen(false)}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
            <Typography variant={"h5"} mb={1} fontWeight={500}>
              Benefits
            </Typography>
            <ul>
              {selectedVehicle &&
                selectedVehicle.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
            </ul>

            {selectedVehicle &&
              selectedVehicle.withdrawalsAndContibutionRestrictions && (
                <>
                  <Typography variant={"h5"} mb={1} mt={2} fontWeight={500}>
                    Withdrawals and Contribution Restrictions
                  </Typography>
                  <ul>
                    {selectedVehicle &&
                      selectedVehicle.withdrawalsAndContibutionRestrictions.map(
                        (withdrawalsAndContibutionRestriction, index) => (
                          <li key={index}>
                            {withdrawalsAndContibutionRestriction}
                          </li>
                        )
                      )}
                  </ul>
                </>
              )}
          </DialogContent>

          <DialogActions>
            {shouldRenderContactUs ? (
              <PrimaryButton
                sx={{ borderRadius: "30px", m: 1, minWidth: "130px" }}
                onClick={() => handleOpenContactUs()}
              >
                Contact Us
              </PrimaryButton>
            ) : (
              <PrimaryButton
                onClick={() => {
                  onNext(selectedVehicle);
                }}
                sx={{ borderRadius: "30px", m: 1, minWidth: "130px" }}
              >
                Select Product
              </PrimaryButton>
            )}
          </DialogActions>
        </Dialog>

        <Dialog
          open={confirmResetOpen}
          onClose={handleCloseReset}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Changing your Investment Purpose?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to change your Investment Purpose? This will
              reset all your progress. This action can not be reversed.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseReset}>Cancel</Button>
            <Button onClick={confirmChangeVehicle} autoFocus>
              Change to {watchVehicle}
            </Button>
          </DialogActions>
        </Dialog>

        <ContactUsDialog
          open={openContactUs}
          onClose={() => setOpenContactUs(false)}
          selectedVehicle={selectedVehicle}
        />
      </>
    );
  };

  return (
    <InvestNowStepper
      selectedStep={0}
      getStepContent={() => stepperContent()}
      checkValidation={() => onValidation()}
      onNext={() => handleSubmit(onSubmit)()}
    />
  );
}

export default InvestmentSelect;
